var _Tooltip;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import { flushSync } from 'react-dom';
import classNames from 'classnames';
import Log from '@deephaven/log';
import Popper from "./Popper.js";
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
var log = Log.module('Tooltip');
/**
 * Component that can be added to an element to automatically display a tooltip.
 * Content is mounted lazily, so don't worry about complex tooltips!
 *
 * Usage:
 * <div className="parent-container">
 *   Hover this container to see a tooltip
 *   <Tooltip>
 *     <div>My tooltip content goes here!</div>
 *   </Tooltip>
 * </div>
 */
class Tooltip extends Component {
  static handleHidden() {
    Tooltip.shownTooltipCount -= 1;
    if (Tooltip.shownTooltipCount === 0) {
      Tooltip.lastHiddenTime = Date.now();
    }
  }
  static handleShown() {
    Tooltip.shownTooltipCount += 1;
  }
  constructor(props) {
    super(props);
    _defineProperty(this, "container", void 0);
    _defineProperty(this, "popper", void 0);
    _defineProperty(this, "parent", void 0);
    // This is platform dependent of Node/DOM
    // Jest requires Node types
    _defineProperty(this, "timer", void 0);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleWindowMouseMove = this.handleWindowMouseMove.bind(this);
    this.handleWheel = this.handleWheel.bind(this);
    this.handleTimeout = this.handleTimeout.bind(this);
    this.handleExited = this.handleExited.bind(this);
    this.stopShowingTooltip = this.stopShowingTooltip.bind(this);
    this.container = /*#__PURE__*/React.createRef();
    this.popper = /*#__PURE__*/React.createRef();
    this.parent = null;
    this.timer = null;
    this.state = {
      isShown: false
    };
  }
  componentDidMount() {
    this.startListening();
    var timeout = this.props.timeout;
    if (timeout === 0) {
      this.show();
    }
  }
  componentDidUpdate(prevProps, prevState) {
    var oldIsShown = prevState.isShown;
    var isShown = this.state.isShown;
    if (isShown !== oldIsShown) {
      if (isShown) {
        Tooltip.handleShown();
      } else {
        Tooltip.handleHidden();
      }
    }
  }
  componentWillUnmount() {
    this.stopListening();
    this.stopListeningWindow();
    this.stopTimer();
    var isShown = this.state.isShown;
    if (isShown) {
      Tooltip.handleHidden();
    }
  }
  startListening() {
    if (!this.container.current || !this.container.current.parentElement) {
      log.error("Tooltip doesn't have a container or a parent set!");
      return;
    }
    this.parent = this.container.current.parentElement;
    this.parent.addEventListener('mousemove', this.handleMouseMove);
    this.parent.addEventListener('mouseleave', this.handleMouseLeave);
    this.parent.addEventListener('mousedown', this.stopShowingTooltip);
  }
  stopListening() {
    if (!this.parent) {
      return;
    }
    this.parent.removeEventListener('mousemove', this.handleMouseMove);
    this.parent.removeEventListener('mouseleave', this.handleMouseLeave);
    this.parent.removeEventListener('mousedown', this.stopShowingTooltip);
  }
  startListeningWindow() {
    window.addEventListener('mousemove', this.handleWindowMouseMove, true);
    window.addEventListener('contextmenu', this.stopShowingTooltip, true);
    window.addEventListener('wheel', this.handleWheel);
  }
  stopListeningWindow() {
    window.removeEventListener('mousemove', this.handleWindowMouseMove, true);
    window.removeEventListener('contextmenu', this.stopShowingTooltip, true);
    window.removeEventListener('wheel', this.handleWheel);
  }
  handleMouseMove() {
    this.startTimer();
  }
  handleWheel() {
    var isShown = this.state.isShown;
    if (this.popper.current && this.parent && isShown) {
      if (!this.popper.current.element.matches(':hover') && !this.parent.matches(':hover')) {
        this.stopTimer();
        this.hide();
      }
    }
  }
  handleMouseLeave() {
    var isShown = this.state.isShown;
    this.stopTimer();
    var interactive = this.props.interactive;
    if (!interactive && isShown) {
      this.hide();
    }
  }
  handleTimeout() {
    this.show();
  }
  handleWindowMouseMove(event) {
    var mouseX = event.clientX;
    var mouseY = event.clientY;
    var isShown = this.state.isShown;
    if (!this.popper.current || !this.parent) {
      return;
    }
    var popperRect = this.popper.current.element.getBoundingClientRect();
    var parentRect = this.parent.getBoundingClientRect();
    if (mouseX >= popperRect.left && mouseX <= popperRect.left + popperRect.width && mouseY >= popperRect.top && mouseY <= popperRect.top + popperRect.height) {
      this.handleMouseMove();
    } else if (mouseX >= parentRect.left && mouseX <= parentRect.left + parentRect.width && mouseY >= parentRect.top && mouseY <= parentRect.top + parentRect.height) {
      this.handleMouseMove();
    } else if (isShown) {
      this.stopTimer();
      this.hide();
    }
  }
  startTimer() {
    this.stopTimer();
    var _this$props = this.props,
      timeout = _this$props.timeout,
      reshowTimeout = _this$props.reshowTimeout;
    var timerTimeout = timeout;
    if (Tooltip.shownTooltipCount > 0 || Date.now() - Tooltip.lastHiddenTime < Tooltip.triggerReshowThreshold) {
      timerTimeout = reshowTimeout;
    }
    this.timer = window.setTimeout(this.handleTimeout, timerTimeout);
  }
  stopTimer() {
    if (this.timer != null) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }
  show() {
    var isShown = this.state.isShown;
    this.stopTimer();
    if (!isShown) {
      var _this$popper$current;
      (_this$popper$current = this.popper.current) === null || _this$popper$current === void 0 || _this$popper$current.show();
      // This is needed for the positioning to work consistently.
      // Without this, the tooltip sometimes overflows the screen
      // or ends up in a different position when hovered a second time.
      flushSync(() => {
        this.setState({
          isShown: true
        });
      });
      var interactive = this.props.interactive;
      if (interactive) {
        this.startListeningWindow();
      }
    }
  }
  hide() {
    var _this$popper$current2;
    (_this$popper$current2 = this.popper.current) === null || _this$popper$current2 === void 0 || _this$popper$current2.hide();
    this.stopListeningWindow();
  }
  update() {
    var _this$popper$current3;
    (_this$popper$current3 = this.popper.current) === null || _this$popper$current3 === void 0 || _this$popper$current3.scheduleUpdate();
  }
  handleExited() {
    this.setState({
      isShown: false
    });
    var onExited = this.props.onExited;
    onExited();
  }
  stopShowingTooltip() {
    var isShown = this.state.isShown;
    this.stopTimer();
    if (isShown) {
      this.hide();
    }
  }
  render() {
    var _this$props2 = this.props,
      interactive = _this$props2.interactive,
      children = _this$props2.children,
      referenceObject = _this$props2.referenceObject,
      popperClassName = _this$props2.popperClassName,
      dataTestId = _this$props2['data-testid'],
      onEntered = _this$props2.onEntered;
    var isShown = this.state.isShown;
    var options = this.props.options;
    options = _objectSpread({
      placement: 'bottom'
    }, options);
    return /*#__PURE__*/_jsx("div", {
      ref: this.container,
      style: {
        display: 'none'
      },
      "data-testid": dataTestId,
      children: /*#__PURE__*/_jsx(Popper, {
        className: classNames(popperClassName, 'popper-tooltip'),
        options: options,
        ref: this.popper,
        onEntered: onEntered,
        onExited: this.handleExited,
        interactive: interactive,
        referenceObject: referenceObject,
        children: /*#__PURE__*/_jsxs("div", {
          className: "tooltip-content",
          children: [" ", isShown && children]
        })
      })
    });
  }
}
_Tooltip = Tooltip;
_defineProperty(Tooltip, "defaultTimeout", 500);
_defineProperty(Tooltip, "defaultReshowTimeout", 100);
_defineProperty(Tooltip, "triggerReshowThreshold", 300);
_defineProperty(Tooltip, "shownTooltipCount", 0);
_defineProperty(Tooltip, "lastHiddenTime", Date.now());
_defineProperty(Tooltip, "defaultProps", {
  interactive: false,
  options: {},
  popperClassName: '',
  reshowTimeout: _Tooltip.defaultReshowTimeout,
  timeout: _Tooltip.defaultTimeout,
  onEntered: () => undefined,
  onExited: () => undefined,
  'data-testid': undefined
});
export default Tooltip;
//# sourceMappingURL=Tooltip.js.map